// extracted by mini-css-extract-plugin
export default {"scroll-indicator":"ScrollIndicator_scroll-indicator__yqReS","zoomInFadeIn":"ScrollIndicator_zoomInFadeIn__j+9SB","arrow":"ScrollIndicator_arrow__Fx5TG"};